/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface IdNameListItemProps {
  id: string;
  name: string;
}

export class IdNameListItemRecord extends Record<IdNameListItemProps>({
  id: null as any,
  name: null as any,
}) {
  public static fromJS(json: { id: string; name: string }): IdNameListItemRecord {
    if (json == null) {
      throw new Error('IdNameListItemRecord.fromJS: parameter cannot be null');
    }
    return new IdNameListItemRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'IdNameListItemJson.id',
      ),
      name: getFromOrThrow(json, (j) => j.name, 'IdNameListItemJson.name'),
    });
  }

  public static fromJSUnsafe(json: { id: string; name: string }): [IdNameListItemRecord, Error[]] {
    if (json == null) {
      throw new Error('IdNameListItemRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new IdNameListItemRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'IdNameListItemJson.id',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      name: tryOrDefault(
        () => getFromOrThrow(json, (j) => j.name, 'IdNameListItemJson.name'),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: IdNameListItemProps) {
    super(props);
    if (props == null) {
      throw new Error('IdNameListItemRecord constructor parameter cannot be null');
    }
  }
}

export abstract class IdNameListItemViewModelBase implements IdNameListItemProps {
  protected readonly _props: IdNameListItemProps;
  private _json?: IdNameListItemProps;

  get id(): string {
    return this._props.id;
  }
  get name(): string {
    return this._props.name;
  }

  constructor(props: IdNameListItemProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
        name: this._props.name,
      };
    }
    return this._json;
  }
}
